import { useState } from "react";
import { faqs } from "@/mocks/manga";

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <section id="faq" className="bg-background-100/70 py-14 md:py-20">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <div className="mx-auto grid max-w-7xl gap-10 px-4 md:px-6 lg:grid-cols-[1fr_1.4fr] lg:items-start">
        <div>
          <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
            <i className="ri-question-line text-sm" />
            常见问题
          </span>
          <h2 className="font-heading mt-3 text-3xl text-foreground-950 md:text-4xl">
            关于追更与下载的疑问
          </h2>
          <p className="mt-3 text-sm leading-6 text-foreground-600">
            把追更泡在我家的辣妹时最常问到的问题整理在这里：完结进度、全集目录、下载入口与汉化状态，一页讲清。仍有疑问可通过下方联系方式向我们反馈。
          </p>
          <a
            href="mailto:paozai@example.com"
            className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-mail-line text-base" />
            联系我们
          </a>
        </div>

        <div className="space-y-3">
          {faqs.map((f, i) => {
            const open = openIndex === i;
            return (
              <div
                key={f.q}
                className="overflow-hidden rounded-lg bg-background-50 ring-1 ring-background-200/70"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? null : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  aria-expanded={open}
                >
                  <h3 className="text-sm font-medium text-foreground-950 md:text-base">
                    {f.q}
                  </h3>
                  <i
                    className={`${
                      open ? "ri-subtract-line" : "ri-add-line"
                    } shrink-0 text-lg text-primary-600 transition-transform`}
                  />
                </button>
                {open && (
                  <p className="border-t border-background-200/70 px-5 py-4 text-sm leading-7 text-foreground-700">
                    {f.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}